import { Redirect } from 'react-router-dom'
import RedirectOldUrl from './RedirectOldUrl'
import { ELASTICFORM_PATH, MAIN_PATH } from './RootConstants'
import { RouteConfig } from './router/Routes'
import { firstLoginFlowRoutes } from './views/first-login-flow/firstLoginFlowRoutes'
import formsRoutes from './views/forms/formsRoutes'
import fundingRoutes from './views/funding/FundingRoutes'
import { GRANTS_PATH } from './views/grants/GrantsConstants'
import grantsRoutes from './views/grants/GrantsRoutes'
import dmahRoutes from './views/internal/DMAH/dmahRoutes'
import internalRoutes from './views/internal/InternalRoutes'
import { resourceInventoryRoutes } from './views/resources/ResourceRoutes'
import satRoutes from './views/self-assessment/SATRoutes'
import sessionRoutes, { NOT_FOUND_PATH } from './views/sessions/SessionRoutes'
import surveyRoutes from './views/surveys/SurveyRoutes'
import vivreEnVilleRoutes from './views/vivre-en-ville/VivreEnVilleRoutes'

const redirectOldUrl = [
  {
    path: ELASTICFORM_PATH + '/:wildcard/:addressString',
    exact: true,
    render: (props) => <RedirectOldUrl {...props} />
  }
]

const redirectRoute = [
  {
    path: MAIN_PATH,
    exact: true,
    // component: () => <Redirect to="/dashboard/learning-management" />
    // TODO: handle redirect from login and default to home
    // component: () => <Redirect to='/grants/ApplicationList' />
    component: () => <Redirect to={GRANTS_PATH.HOME} />
  }
]

const errorRoute = [
  {
    component: () => <Redirect to={NOT_FOUND_PATH} />
  }
]

const routes = [
  ...resourceInventoryRoutes,
  ...satRoutes,
  ...fundingRoutes,
  ...redirectOldUrl,
  ...surveyRoutes,
  ...internalRoutes,
  ...grantsRoutes,
  ...sessionRoutes,
  ...formsRoutes,
  ...vivreEnVilleRoutes,
  ...dmahRoutes,
  ...redirectRoute,
  ...firstLoginFlowRoutes,
  ...errorRoute
] as RouteConfig[]

export default routes
